import { ReactComponent as EmptyPanelDroneIcon } from '@assets/components/panel/notification/empty-panel-drone-icon.svg';
import { IcColorStatusSActive } from '@assets/icons/24x24';
import { Center, For, HStack, Icon, Spinner, Text, VStack } from '@chakra-ui/react';
import { ScrollArea } from '@components/ui/ScrollArea';
import { getAlertLevelColor } from '@utils/data/notification.utils';
import { format } from 'date-fns';
import { FormattedMessage } from 'react-intl';

import { AlertLight } from '@/types/data/data.types';

type Props = {
  alerts: AlertLight[];
  isLoading: boolean;
};

export default function TechnicalAlertList({ alerts, isLoading }: Readonly<Props>) {
  return (
    <VStack gap={0.25} flex={1} height="100%" backgroundColor="neutral.900">
      <HStack height="64px" width="100%" flexShrink={0} paddingLeft={3} backgroundColor="neutral.700">
        <Text fontWeight="medium">
          <FormattedMessage id="components.monitoring.sensorDetail.availability.technicalAlerts" />
        </Text>
      </HStack>
      <ScrollArea backgroundColor="neutral.850">
        <VStack width="100%" flex={1} minHeight={0} gap={0.25}>
          {isLoading ? (
            <Center width="100%" height="100%" backgroundColor="neutral.850">
              <Spinner color="neutral.300" boxSize="48px" />
            </Center>
          ) : (
            <For
              each={alerts}
              fallback={
                <Center width="100%" height="100%" backgroundColor="neutral.850">
                  <VStack gap={2}>
                    <Icon as={EmptyPanelDroneIcon} boxSize="80px" />
                    <Text color="neutral.200" textAlign="center" userSelect="none">
                      <FormattedMessage id="components.monitoring.sensorDetail.availability.emptyAlert" />
                    </Text>
                  </VStack>
                </Center>
              }
            >
              {(item) => (
                <HStack
                  width="100%"
                  height="64px"
                  flexShrink={0}
                  gap={2}
                  paddingLeft={3}
                  key={item.id}
                  backgroundColor="neutral.800"
                >
                  <HStack width="230px" gap={1}>
                    <Icon boxSize="16px" color={getAlertLevelColor(item.level)} as={IcColorStatusSActive} />
                    <Text color="neutral.200" textAlign="center" userSelect="none">
                      <FormattedMessage id={`components.monitoring.sensorDetail.availability.level.${item.level}`} />
                    </Text>
                  </HStack>
                  <Text color="neutral.300">
                    <FormattedMessage
                      id={
                        item.endTime === null
                          ? 'components.monitoring.sensorDetail.availability.onGoingAlertDate'
                          : 'components.monitoring.sensorDetail.availability.alertDate'
                      }
                      values={{
                        startTime: (
                          <Text as="span" key="startTime" color="neutral.white">
                            {format(item.startTime, "dd/MM/yyyy - HH':'mm")}
                          </Text>
                        ),
                        endTime: (
                          <Text as="span" key="endTime" color="neutral.white">
                            {item.endTime && format(item.endTime, "dd/MM/yyyy - HH':'mm")}
                          </Text>
                        ),
                      }}
                    />
                  </Text>
                </HStack>
              )}
            </For>
          )}
        </VStack>
      </ScrollArea>
    </VStack>
  );
}
